'use client'

// SUMMARY: The permanent way back into the consent dialog. Art. 7(3) GDPR requires withdrawing consent to
// be as easy as giving it, so this sits in the footer's legal column alongside the privacy policy - not
// buried in a settings page.

import { useTranslations } from 'next-intl'
import { openConsentSettings } from '@/components/consent/cookie-banner'

export function ConsentSettingsLink() {
	const t = useTranslations('consent')

	return (
		<button
			type="button"
			onClick={openConsentSettings}
			className="cursor-pointer text-left transition-colors hover:text-foreground"
		>
			{t('footerLink')}
		</button>
	)
}
